import { useRecoilValue } from "recoil";

import mainStore, { storeSetSuperbet } from "src/stores/main";
import { useTranslation } from "src/hooks/translation";
import ToggleSwitch from "src/common/components/toggleSwitch";
import { useConfig } from "src/hooks/config";
import { BetTypeEnum } from "src/constants/enums/betType";

import superbetFireImage from "../../../../assets/images/superbet_fire.png";

import "./style.scss";

const SuperbetToggle = () => {
	const config = useConfig();
	const t = useTranslation();
	const { betType, isSuperbet } = useRecoilValue(mainStore);

	const toggleSuperbet = () => !config.enableAutomaticSuperbet && storeSetSuperbet(!isSuperbet);

	if (!config.enableSuperbetToggle || betType === BetTypeEnum.System) return null;

	return (
		<div className="B-betslip-superbet-toggle">
			<div className={`B-content ${isSuperbet ? "B-active" : ""}`}>
				<img src={superbetFireImage} alt="fire" />
				<span className="B-superbet">{t("Superbet")}</span>
				<ToggleSwitch onChange={toggleSuperbet} checked={isSuperbet} />
			</div>
		</div>
	);
};

export default SuperbetToggle;
